import { useState, useEffect } from 'react';
import { updateConsent, track } from '../lib/analytics';

const STORAGE_KEY = 'gt-consent';

// Dispatching this event from anywhere re-opens the banner (e.g. Footer "Cookie preferences").
export const OPEN_CONSENT_EVENT = 'gt-open-consent';

export default function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'granted') {
        updateConsent(true);
      } else if (saved === 'denied') {
        updateConsent(false);
      } else {
        // No saved preference: show banner, keep default denied
        setShow(true);
      }
    } catch {
      // localStorage unavailable (private mode, etc.)
      setShow(true);
    }

    const handleOpen = () => setShow(true);
    window.addEventListener(OPEN_CONSENT_EVENT, handleOpen);
    return () => window.removeEventListener(OPEN_CONSENT_EVENT, handleOpen);
  }, []);

  const handleGrant = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'granted');
    } catch { /* ignore */ }
    updateConsent(true);
    track('consent_updated', { consent_analytics: 'granted' });
    setShow(false);
  };

  const handleDeny = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'denied');
    } catch { /* ignore */ }
    updateConsent(false);
    track('consent_updated', { consent_analytics: 'denied' });
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: '#201F1D',
        color: '#FAF9F7',
        padding: '16px clamp(20px, 6vw, 72px)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px 20px',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: '1px solid rgba(250,249,247,.14)',
      }}
    >
      <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5, maxWidth: 640 }} >
        We use cookies and analytics to understand how visitors use the site and improve it.
        Analytics uses pseudonymous identifiers — we never send names, phone numbers or email addresses to analytics.{" "}
        <a
          href="/privacy-policy"
          style={{ color: '#B68235', textDecoration: 'underline', textUnderlineOffset: 2 }}
        >
          Privacy Policy
        </a>
      </p>
      <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
        <button
          type="button"
          onClick={handleGrant}
          style={{
            border: 'none',
            background: '#B68235',
            color: '#201F1D',
            fontFamily: 'inherit',
            fontWeight: 600,
            fontSize: 14,
            padding: '10px 18px',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          Accept
        </button>
        <button
          type="button"
          onClick={handleDeny}
          style={{
            border: '1px solid rgba(250,249,247,.35)',
            background: 'transparent',
            color: '#FAF9F7',
            fontFamily: 'inherit',
            fontWeight: 500,
            fontSize: 14,
            padding: '10px 18px',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          Decline
        </button>
      </div>
    </div>
  );
}
